<script setup lang="ts">
import { defineModel, defineProps } from 'vue'

import type { SideMenuDisplayMode } from '@/constants/enums/SideMenuDisplayMode'

import AAppLogo from '@/components/atoms/AAppLogo/index.vue'
import AIconBurger from '@/components/atoms/AIconBurger/index.vue'
import AHeaderNavigation from '@/components/organisms/ALayoutHeader/components/AHeaderNavigation/index.vue'
import { useDomSizeStore } from '@/stores/domSizeStore'

type Props = {
  isGuest: boolean
  sideMenuDisplayMode: SideMenuDisplayMode
}
const props = defineProps<Props>()

const modelValue = defineModel<boolean>()

const layoutHeaderStore = useDomSizeStore('layoutHeader')
layoutHeaderStore.useObservers()
</script>

<template>
  <div
    :ref="layoutHeaderStore.state.elementRef"
    class="a-mobile-header"
  >
    <div class="a-mobile-header__menu">
      <AIconBurger @click="modelValue = true" />
      <div class="logo">
        <AAppLogo color="white" />
      </div>
    </div>
    <AHeaderNavigation
      :is-guest="props.isGuest"
      :side-menu-display-mode="props.sideMenuDisplayMode"
    />
  </div>
</template>

<style lang="scss" scoped>
.a-mobile-header {
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 60px;
  padding-right: 25px;
  color: rgb(var(--v-theme-ui-text-white));
  background-color: rgb(var(--v-theme-primary));

  /* shadow-md  中程度のドロップシャドウ */
  box-shadow: 0 2px 4px rgba(var(--v-theme-ui-gray4), 0.2);

  .a-mobile-header__menu {
    display: flex;
    gap: 19px;
    align-items: center;
    padding: 20px;

    .logo {
      width: 180px;
    }
  }
}
</style>
